// src/firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyCZCxj5hVg2hLwTfuHDs4UVSKRyYal-AVE",
  authDomain: "blue-lotus-cabana.firebaseapp.com",
  projectId: "blue-lotus-cabana",
  storageBucket: "blue-lotus-cabana.firebasestorage.app",
  messagingSenderId: "701087355264",
  appId: "1:701087355264:web:6f514081f48a747abfb165",
  measurementId: "G-BGY7HC2ML1"
};

const app = initializeApp(firebaseConfig);

export const storage = getStorage(app);
export const db = getFirestore(app);
